import { useState } from "react";
import { BsEnvelope } from "react-icons/bs";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import {
  API_AUTH_ENDPOINT,
  API_BASE_URL,
  API_FORGOT_PASSWORD,
} from "../../constants/constants";
import { useNavigate, Link } from "react-router-dom";
import "../../auth/login/LoginPage.css";
import Seo from '../../seo/Seo';
import { ConsentGate } from '../../privacy/ConsentUI';

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const forgotPasswordApi = `${API_BASE_URL}${API_AUTH_ENDPOINT}${API_FORGOT_PASSWORD}`;
  const [email, setEmail] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [emailValid, setEmailValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailChange = (e) => {
    const v = e.target.value;
    setEmail(v);
    setEmailValid(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v));
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(forgotPasswordApi, { EmailAddress: email });
      if (response.status === 200) {
        setSuccessMessage("Reset link sent! Check your email.");
        setErrorMessage("");
        setTimeout(() => navigate("/login"), 4000);
      }
    } catch {
      setErrorMessage("Something went wrong. Please try again.");
      setSuccessMessage("");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Seo path="/forgot-password" />
      <div className="login-card">
        <div className="login-card-inner">
          <div className="login-icon">🔑</div>
          <h1>Reset Password</h1>
          <p className="login-sub">We'll send a reset link to your email</p>

          {errorMessage && <p className="error-msg">{errorMessage}</p>}
          {successMessage ? (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "2.5rem", marginBottom: 12 }}>✅</div>
              <p style={{ color: "#059669", fontWeight: 600 }}>{successMessage}</p>
              <p style={{ color: "#64748b", fontSize: "0.85rem" }}>Redirecting to login...</p>
            </div>
          ) : (
            <>
              <div className="input-group">
                <span className="input-icon"><BsEnvelope /></span>
                <input
                  type="email"
                  className="input-field"
                  placeholder="Email address"
                  value={email}
                  onChange={handleEmailChange}
                />
              </div>

              <div style={{ margin: "16px 0", display: "flex", justifyContent: "center" }}>
                <ConsentGate
                  category="security"
                  title="Security check (Google reCAPTCHA)"
                  what="To stop automated reset requests this form uses Google reCAPTCHA. Loading it sends your IP address, browser details and how you use this page to Google, which may set a cookie. Nothing is loaded until you allow it."
                >
                  <ReCAPTCHA
                    sitekey="6LfmbRkTAAAAAFe9WOdrSVqwWyZdqqjQ7CpVK5J3"
                    onChange={() => setCaptchaVerified(true)}
                    size="normal"
                  />
                </ConsentGate>
              </div>

              <button
                className="btn-submit"
                disabled={!captchaVerified || !emailValid || isLoading}
                onClick={handleSubmit}
              >
                {isLoading ? "Sending..." : "Send Reset Link"}
              </button>

              <p className="login-footer-text">
                Remember your password? <Link to="/login" className="link-accent">Sign in</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
